import permissionsFormated from "../Components/permissions"

const usersViewConfigBabel = [
    {
        apartado: permissionsFormated.dashboard,
        action: 'read',
        subject: 'home'
    },
    {
        apartado: permissionsFormated.image_analyzer,
        action: 'read',
        subject: 'imageModule'
    },
    {
        apartado: permissionsFormated.renovar_plan,
        action: 'read',
        subject: 'UpgradePaymentModule'
    },
    {
        apartado: permissionsFormated.solicitar_creditos_extras,
        action: 'read',
        subject: 'ExtraStimulusModule'
    },
    {
        apartado: permissionsFormated.cambiar_contrasena,
        action: 'read',
        subject: 'changePass'
    },
    {
        apartado: permissionsFormated.ver_perfil,
        action: 'read',
        subject: 'profile'
    },
    {
        apartado: permissionsFormated.actualizar_plan,
        action: 'read',
        subject: 'pricing'
    },
    {
        apartado: permissionsFormated.ver_apartado_usuarios,
        action: 'read',
        subject: 'UsersModule'
    },
    {
        apartado: 'all',
        action: 'read',
        subject: 'HelpCenter'
    }

]

export default usersViewConfigBabel